import {createAction} from '@reduxjs/toolkit'
import {Event as Event_V3} from '@wix/ambassador-events-v3-event/types'
import {isEventDetailsPageHiddenInternal} from '@wix/wix-events-commons-statics'
import {navigateToDetailsPage} from '../../../../commons/services/navigation'
import {isEventRestricted} from '../selectors/events'
import {createAsyncAction} from '../services/redux-toolkit'
import {ensureLoggedIn} from './members'

export const navigateToPage = createAsyncAction<boolean, {event: wix.events.Event | Event_V3}>(
  'NAVIGATE_TO_PAGE',
  async ({event}, {dispatch, getState, extra: {wixCodeApi}}) => {
    dispatch(rsvpButtonClicked({event}))
    const state = getState()
    const detailsPageEnabled = !isEventDetailsPageHiddenInternal(event)

    const isRestricted = isEventRestricted(state, event)
    if (!isRestricted || (await dispatch(ensureLoggedIn()))) {
      await navigateToDetailsPage(event, detailsPageEnabled, wixCodeApi)

      return true
    }

    return false
  },
)

export const onLinkNavigatedToPage = createAction<{event: wix.events.Event | Event_V3}>('ON_LINK_NAVIGATED_TO_PAGE')

export const rsvpButtonClicked = createAction<{event: wix.events.Event | Event_V3}>('RSVP_BUTTON_CLICKED')

export const navigatedToPage = createAction<{event: wix.events.Event | Event_V3}>('NAVIGATED_TO_PAGE')
